<template>
    <v-layout row>
        <v-flex>
            <v-menu
                ref="dateDialog"
                :close-on-content-click="false"
                v-model="dateDialog"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  :value="pickerValue"
                  :label="label"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="pickerValue"></v-date-picker>
            </v-menu>
        </v-flex>
        <v-flex>
            <v-menu
                ref="timeDialog"
                :close-on-content-click="false"
                v-model="timeDialog"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  :value="timePickerValue"
                  label="Ora"
                  readonly
                ></v-text-field>
                <v-time-picker v-model="timePickerValue"></v-time-picker>
            </v-menu>
        </v-flex>
    </v-layout>

</template>

<script>
import moment from 'moment';

export default {
  props: ['value', 'label'],

  data() {
    return {
      dateModel: this.filterDate(this.value),
      dateDialog: false,
      timeModel: this.filterTime(this.value),
      timeDialog: false
    };
  },

  computed: {
    pickerValue: {
      get() {
        return this.dateModel;
      },
      set(value) {
        this.dateModel = value;
        this.dateDialog = false;
        this.updateDateTime();
      }
    },

    timePickerValue: {
      get() {
        return this.timeModel;
      },
      set(value) {
        this.timeModel = value;
        this.timeDialog = false;
        this.updateDateTime();
      }
    }
  },

  created() {
    this.updateDateTime();
  },

  methods: {
    filterDate(date) {
      return moment(date).format('YYYY-MM-DD');
    },

    filterTime(time) {
      return moment(time).format('hh:mm');
    },

    updateDateTime() {
      this.$emit(
        'input',
        moment(this.pickerValue + ' ' + this.timePickerValue).format(
          'YYYY-MM-DD hh:mm:ss'
        )
      );
    }
  }
};
</script>

